import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { themeGet } from '@styled-system/theme-get';
import { switchProp } from 'styled-tools';
import { PositionProps, SpaceProps } from 'styled-system';
import Box from '../../atoms/Box';
import IconRankS from '../../atoms/Icon/IconRankS';
import IconRankL from '../../atoms/Icon/IconRankL';

const Wrapper = styled(Box)`
  display: inline-block;
  vertical-align: middle;
  position: relative;
`;
type RankBoxType = {
  name?: string;
};

const RankBox = styled(Box)<RankBoxType>`
  position: absolute;
  left: 0;
  width: 100%;
  text-align: center;
  ${switchProp('name', {
    's-rank': css`
      top: 12px;
      font-weight: bold;
      width: 26.5px;
      font-size: ${themeGet('fontSizes.xxs')}px;
      color: ${themeGet('gold.900')};
    `,
    'l-rank': css`
      top: 14px;
      font-size: ${themeGet('fontSizes.bodyHeading.s')}px;
      font-family: ${themeGet('fonts.headings')};
      color: #fff;
    `,
  })};
`;

const RankComponent: any = ({
  rank,
  name = 's-rank',
  ...props
}: {
  rank: number;
  name: any;
} & PositionProps &
  SpaceProps) => {
  if (rank === 0) {
    return null;
  }

  return (
    <Wrapper {...props}>
      {name === 's-rank' && <IconRankS color="white" />}
      {name === 'l-rank' && <IconRankL />}
      <RankBox name={name}>{Math.round(rank)}</RankBox>
    </Wrapper>
  );
};

RankComponent.propTypes = {
  name: PropTypes.oneOf(['s-rank', 'l-rank']),
  rank: PropTypes.number.isRequired,
};

export default RankComponent;
